export const NOTIFICATIONS_STATE_TOKEN = 'NOTIFICATIONS';

export const NOTIFICATIONS_API_PATHS = {
    notifications: `${window.location.origin}/api/notifications`
};
